import { closePopupOpenAnimation, startPopupOpenAnimation } from '../elements/popup-animation'
import { playAudio, stopAudio } from '../elements/audio-player'

let audioPopup = '.js-audio-timeline-popup'
let playAudioButton = '.play-audio-story-recording'
let openTrigger = '#audio-timeline .column-description, #audio-timeline .column-image .background-image'

let $body = $('body')


function closePopup(){
  if($(audioPopup).hasClass('open')) {
    $(audioPopup).removeClass('open')
    stopAudio()
    closePopupOpenAnimation()
  }
}

function showAudioTimelinePopup(){
  $(audioPopup).addClass('open')
}


$body.on('click', '.js-audio-timeline-popup .js-close-popup', function(e) {
  closePopup()
});

$(document).keyup(function(e) {
  if (e.key === "Escape") { // escape key maps to keycode `27`
    closePopup()
  }
});


$body.on('click', openTrigger, function (e){

  e.preventDefault()
  stopAudio()
  startPopupOpenAnimation($(this).closest('.timeline-element').find('.timeline-element-description'))

  let trigger = $(this).closest('.timeline-element')
  let image = trigger.find('.background-image').attr('data-full-image')
  let fullContent = trigger.find('.full-content').text()
  let title = trigger.find('p small').text()
  let audioRecording = trigger.find('[data-recording]').attr('data-recording')

  $(audioPopup).find('.popup-content img').attr('src', image)
  $(audioPopup).find('.popup-quote').text(fullContent)
  $(audioPopup).find('.popup-thumbnail-description').text(title)
  $(audioPopup).find('[data-recording]').attr('data-recording', audioRecording)

})


$body.on('click', playAudioButton, function (e){

  e.preventDefault()

  let trigger = $(this)
  let recording = $(this).attr('data-recording')

  playAudio(recording, trigger)



})

export { showAudioTimelinePopup }